<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    ref="gc-base-layout"
    class="production-planning-layout"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Production Planning'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Production Planning'"
        :secondaryLabel="undefined"
      />
    </template>
    <div class="css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <div class="gc-form-header-toolbar">
          <DxToolbar
            class="view-toolbar form-header-toolbar"
            ref="toolbar-header"
          >
            <DxItem
              v-if="getHeaderToolbar.copy.visible == true"
              :options="getHeaderToolbar.copy"
              location="after"
              locate-in-menu="auto"
              :widget="'dxButton'"
            />

            <DxItem
              v-if="getHeaderToolbar.edit.visible == true"
              :options="getHeaderToolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
            />

            <DxItem
              v-if="getHeaderToolbar.close.visible == true"
              :options="getHeaderToolbar.close"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
            />
          </DxToolbar>
        </div>
      </div>

      <div class="gc-header-form">
        <div class="view-card responsive-paddings">
          <gc-form
            :formOptions="{
              gcLabelLocation: 'left',
            }"
            :formItems="getHeaderFormItems"
            :isNormal="true"
            :data-model="loaded ? model : {}"
            :formMode="baseView.mode"
            :fromFrom="'gc-header-form'"
            ref="gc-header-form"
            :checkValid="isValid"
            :validationGroup="'gc-header-form'"
            :scrollingEnabled="false"
            :formContentReady="onHeaderFormContentReady"
            :setCustomizeItem="getCustomizeItem"
          ></gc-form>
        </div>

        <div class="view-card responsive-paddings filter-section">
          <gc-form
            :formOptions="{
              gcLabelLocation: 'left',
            }"
            :formItems="getHeaderFilterItems"
            :isNormal="true"
            :data-model="loaded ? filterModel : {}"
            :formMode="baseView.mode"
            :fromFrom="'gc-header-form-filter'"
            ref="gc-header-form-filter"
            :validationGroup="'gc-header-form-filter'"
            :scrollingEnabled="false"
            :formContentReady="onHeaderFilterFormContentReady"
            :setCustomizeItem="getCustomizeItem"
            :fieldDataChanged="onFieldDataChanged"
          ></gc-form>
        </div>
      </div>

      <div class="gc-details-grid" v-if="loaded && IsPlanCreated">
        <dx-data-grid
          @toolbar-preparing="toolbarPreparing($event)"
          :columns="getColumns"
          :data-source="getDataSource"
          :height="getGridHeight"
          :ref="'dx-data-grid-comp'"
          :twoWayBindingEnabled="false"
          :repaintChangesOnly="true"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          @cell-prepared="onCellPrepared"
          @editor-preparing="onEditorPreparing"
          @content-ready="onContentReady"
        >
          <DxSearchPanel :visible="false" />

          <DxScrolling
            :mode="'virtual'"
            :row-rendering-mode="'virtual'"
            :preload-enabled="true"
          />

          <DxEditing
            :allow-updating="IsEditEnabled"
            :allow-deleting="false"
            mode="cell"
            :new-row-position="'last'"
          />

          <template #dayHeaderCellTemplate="{ data }">
            <div>
              {{ getDateHeaderTemplate(data).caption }} <br />
              ({{ getDateHeaderTemplate(data).date }})
            </div>
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>

          <DxSummary v-if="ShowFooterTotals">
            <DxTotalItem
              v-for="footerItem in getWeekColumns()"
              v-bind:key="footerItem.dataField"
              :column="footerItem.dataField"
              summary-type="sum"
              display-format="{0}"
              :value-format="footerItem.format"
            />
          </DxSummary>

          <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
          <template #masterDetailTemplate="{ data: masterData }">
            <dx-data-grid
              @toolbar-preparing="toolbarPreparing($event)"
              :columns="getChildColumns"
              :data-source="masterData.data.Boms"
              :height="'auto'"
              :twoWayBindingEnabled="false"
              :repaintChangesOnly="true"
              :columnChooser="{
                enabled: false,
              }"
              :pager="{ visible: false }"
              width="auto"
              :ref="'master-grid-' + masterData.data.ProductCode"
              @editor-preparing="onChildEditorPreparing"
            >
              <DxSearchPanel :visible="false" />
              <DxEditing
                :allow-updating="IsEditEnabled"
                :allow-deleting="false"
                mode="cell"
                :new-row-position="'last'"
              />
              <template #dayHeaderCellTemplate="{ data }">
                <div>
                  {{ getDateHeaderTemplate(data).caption }} <br />
                  ({{ getDateHeaderTemplate(data).date }})
                </div>
              </template>

              <template #Decimal="{ data }">
                <GcDecimal :dataValue="data" :format="data.column.format" />
              </template>
            </dx-data-grid>
          </template>
        </dx-data-grid>
      </div>

      <gcPopupProductionPlanningCopy
        :visible="getCopyPlanningVisible"
        @setCopyPlanningVisible="setCopyPlanningVisible"
        :popUpConfig="popUpConfig"
        v-if="getCopyPlanningVisible"
        :displayServerError="displayServerError"
        @refreshPlanning="onRefreshPlanning"
      />
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { mapGetters } from "vuex";
import { getFactorByCode } from "../../../_store/helpers";
import { BranchService } from "../../../_services/api/sales/branch.service";
import { IsResponseDataValid } from "../../../_helpers/ui/helpers";
import validationEngine from "devextreme/ui/validation_engine";
import { ProductionPlanningService } from "../../../_services/api/production/production-planning.service";
import ArrayStore from "devextreme/data/array_store";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { backwardTabbing, forwardTabbing } from "../../../_helpers/ui/keyboard";
import SettingsService from "../../../_services/api/settings/graycorp/settings.service";
import gcPopupProductionPlanningCopy from "../../../popups/production/gc-popup-production-planning-copy";

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: { gcPopupProductionPlanningCopy },
  data() {
    return {
      loaded: false,
      model: {
        DateIn: null,
        BranchCode: null,
        DivisionCode: null,
      },
      filterModel: {
        ProductCategory1Code: null,
        ProductCategory2Code: null,
        ProductCategory3Code: null,
        ProductCategory4Code: null,
        ProductCategoryTypeCode: null,
        ProductCode: null,
      },
      isValid: false,
      defaultBranchCode: null,
      IsPlanCreated: false,
      headerFormHeight: 0,
      dataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      editingDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      IsEditEnabled: false,
      ProductCodes: [],
      ShowFooterTotals: false,
      CopyProductPlanningVisible: false,
      popUpConfig: {},
      factor204: 0,
    };
  },
  async created() {
    await this.$store.dispatch("screenFactors/getFactors", [65, 66, 204]);
    this.defaultBranchCode = getFactorByCode(65).Factorc;
    if (this.defaultBranchCode) {
      const branch = await BranchService.isBranchManufactureBranch(
        this.defaultBranchCode
      );

      if (branch && IsResponseDataValid(branch)) {
        this.model.BranchCode = this.defaultBranchCode;
      }
    }

    if (getFactorByCode(66).Factorc) {
      this.model.DivisionCode = getFactorByCode(66).Factorc;
    }

    let showTotalSetting = await SettingsService.getBySettingNameFromDb(
      "PlanningShowDailyTotals"
    );

    if (showTotalSetting.data.value.length > 0) {
      this.ShowFooterTotals =
        showTotalSetting.data.value[0].SettingValue === "Y";
    }

    // For Development purpose, we are setting the default branch code directly.
    // this.model.DateIn = new Date("2025-11-15");
    // this.model.BranchCode = "01";

    /* Set the page key to force re-rendering when needed */
    this.$nextTick(() => {
      this.loaded = true;
    });
  },
  computed: {
    /**
     * Computed property to get the hotkey save state from Vuex store
     * @returns {boolean} The hotkey save state
     */
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({ getHotKeyEdit: "hotKey/getHotKeyEdit" }),
    ...mapGetters({
      getHotKeyPopupMode: "hotKey/getHotKeyPopupMode",
    }),

    /**
     * Computed property to get the back button route
     * @returns {string} The back button route
     */
    backButtonRoute() {
      return "/home";
    },

    /**
     * Computed property to get the header toolbar configuration
     * @returns {Object} The header toolbar configuration
     */
    getHeaderToolbar() {
      return {
        copy: {
          tabIndex: -1,
          icon: "copy",
          validationGroup: "formsData",
          visible: this.IsPlanCreated,
          onClick: () => {
            this.setCopyPlanningVisible(true);
          },
        },
        edit: {
          icon: "edit",
          visible: this.IsPlanCreated && !this.IsEditEnabled,
          onClick: () => {
            this.onEditPlanClick();
          },
        },
        close: {
          icon: "close",
          visible: this.IsPlanCreated && this.IsEditEnabled,
          onClick: () => {
            this.onReviewPlanClick();
          },
        },
      };
    },

    /**
     * Computed property to get the header form items
     * @returns {Array} The header form items
     */
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              cssClass: "header-form-items",
              colCount: 3,
              items: [
                {
                  screenField: "DateIn",
                  dataField: "DateIn",
                  required: true,
                  editorOptions: {
                    tabIndex: 1,
                    showClearButton: true,
                    onValueChanged: this.onDateInValueChanged,
                  },
                },
                {
                  screenField: "Branch",
                  dataField: "BranchCode",
                  label: {
                    text: "Branch",
                  },
                  required: true,
                  editorOptions: {
                    tabIndex: 2,
                    showClearButton: true,
                    select: ["Code", "Description", "RecordId", "Inactive"],
                  },
                  filter: ["ManufactureFlag", "=", "Y"],
                  displayExpr: (item) => {
                    if (item) return item.Code + " - " + item.Description;
                    else return "";
                  },
                  searchExpr: ["Code", "Description"],
                },
                {
                  screenField: "Division",
                  dataField: "DivisionCode",
                  label: {
                    text: "Division",
                  },
                  editorOptions: {
                    tabIndex: 3,
                    showClearButton: true,
                    select: ["Code", "Description", "RecordId", "Inactive"],
                  },
                  displayExpr: (item) => {
                    if (item) return item.Code + " - " + item.Description;
                    else return "";
                  },
                  searchExpr: ["Code", "Description"],
                  required: true,
                },
              ],
            },
          ],
        },
      ];
    },

    /**
     * Computed property to get the header form items
     * @returns {Array} The header form items
     */
    getHeaderFilterItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              cssClass: "header-form-items",
              colCount: 1,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  cssClass: "header-form-items",
                  colCount: 1,
                  items: [
                    {
                      screenField: "ProductCategory1",
                      dataField: "ProductCategory1Code",
                      editorType: "dxTagBox",
                      label: {
                        text: "Prod Cat 1",
                      },
                      editorOptions: {
                        tabIndex: 4,
                        showClearButton: true,
                        select: ["Code", "Description", "Status", "Inactive"],
                        showSelectionControls: true,
                        selectAllMode: "allPages",
                      },
                      displayExpr: (item) => {
                        if (item) return item.Code + " - " + item.Description;
                        else return "";
                      },
                    },
                    {
                      screenField: "ProductCategory2",
                      dataField: "ProductCategory2Code",
                      editorType: "dxTagBox",
                      label: {
                        text: "Prod Cat 2",
                      },
                      editorOptions: {
                        tabIndex: 5,
                        showClearButton: true,
                        select: ["Code", "Description", "Status", "Inactive"],
                        showSelectionControls: true,
                        selectAllMode: "allPages",
                      },
                      displayExpr: (item) => {
                        if (item) return item.Code + " - " + item.Description;
                        else return "";
                      },
                      searchExpr: ["Code", "Description"],
                    },
                    {
                      screenField: "ProductCategory3",
                      dataField: "ProductCategory3Code",
                      editorType: "dxTagBox",
                      label: {
                        text: "Prod Cat 3",
                      },
                      editorOptions: {
                        tabIndex: 6,
                        showClearButton: true,
                        select: ["Code", "Description", "Status", "Inactive"],
                        showSelectionControls: true,
                        selectAllMode: "allPages",
                      },
                      displayExpr: (item) => {
                        if (item) return item.Code + " - " + item.Description;
                        else return "";
                      },
                      searchExpr: ["Code", "Description"],
                    },
                  ],
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              cssClass: "header-form-items",
              colCount: 1,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  cssClass: "header-form-items",
                  colCount: 1,
                  items: [
                    {
                      screenField: "ProductCategory4",
                      dataField: "ProductCategory4Code",
                      editorType: "dxTagBox",
                      label: {
                        text: "Prod Cat 4",
                      },
                      editorOptions: {
                        tabIndex: 7,
                        showClearButton: true,
                        select: ["Code", "Description", "Inactive"],
                        showSelectionControls: true,
                        selectAllMode: "allPages",
                      },
                      displayExpr: (item) => {
                        if (item) return item.Code + " - " + item.Description;
                        else return "";
                      },
                      searchExpr: ["Code", "Description"],
                    },
                    {
                      screenField: "ProductType",
                      dataField: "ProductCategoryTypeCode",
                      editorType: "dxTagBox",
                      label: {
                        text: "Prod Type",
                      },
                      editorOptions: {
                        tabIndex: 8,
                        showClearButton: true,
                        select: ["Code", "Description", "Inactive"],
                        showSelectionControls: true,
                        selectAllMode: "allPages",
                      },
                      displayExpr: (item) => {
                        if (item) return item.Code + " - " + item.Description;
                        else return "";
                      },
                      searchExpr: ["Code", "Description"],
                    },
                    {
                      screenField: "Product",
                      dataField: "ProductCode",
                      editorType: "dxTagBox",
                      label: {
                        text: "Item Code",
                      },
                      editorOptions: {
                        tabIndex: 9,
                        showClearButton: true,
                        select: [
                          "Code",
                          "Description1",
                          "Description2",
                          "Description3",
                          "RecordId",
                          "Inactive",
                          "Status",
                        ],
                        showSelectionControls: true,
                        selectAllMode: "allPages",
                      },
                      displayExpr: (item) => {
                        if (item) return item.Code + " - " + item.Description1;
                        else return "";
                      },
                      searchExpr: [
                        "Code",
                        "Description1",
                        "Description2",
                        "Description3",
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          cssClass: "generate-button-group",
          items: [
            {
              dataField: "Generate",
              label: {
                text: " ",
                visible: false,
              },
              editorType: "dxButton",
              cssClass: "btn-generate",
              editorOptions: {
                validationGroup: "gc-header-form",
                onClick: async () => {
                  this.onReviewPlanClick();
                },
                text: "Review Plan",
                type: "default",
                rtlEnabled: false,
                tabIndex: 19,
                onKeyDown: (e) => {
                  if (forwardTabbing({ event: e })) {
                    e.preventDefault();
                    if (this.IsPlanCreated && this.IsEditEnabled) {
                      const dataGrid = this.getDataGridInstance();
                      const visibleRows = dataGrid.getVisibleRows();
                      const rowData = visibleRows[0].data;

                      const nextEditableDay = this.getNextEditableDay({
                        ...rowData,
                        ...this.getParentEditableDays(rowData),
                      });

                      if (nextEditableDay) {
                        this.focusOnParentGridCell(
                          0,
                          "Total" + nextEditableDay
                        );
                      } else {
                        this.focusOnBomListFirstRecord(e, rowData);
                      }
                    }
                  }
                },
              },
            },
          ],
        },
      ];
    },

    /**
     * Computed property to get the grid height
     * @returns {number} The grid height
     */
    getGridHeight() {
      return this.gridHeight - 20 - 55 - this.headerFormHeight;
    },

    /**
     * Computed property to get the data grid columns
     * @returns {Array} The data grid columns
     */
    getColumns() {
      return [
        {
          caption: "Product Code",
          dataField: "ProductCode",
          width: ColumnWidth.ProductCode.width,
          minWidth: ColumnWidth.ProductCode.minWidth,
          sortIndex: 0,
          sortOrder: "asc",
          allowEditing: false,
        },
        {
          caption: "Description",
          dataField: "ProductDescription1",
          minWidth: ColumnWidth.Description.minWidth,
          allowEditing: false,
        },
        {
          caption: "Batch Qty",
          dataField: "BatchSize",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: false,
        },
      ].concat(this.getWeekColumns(false));
    },

    /**
     * Computed property to get the data source for the data grid
     * @returns {ArrayStore} The data source
     */
    getDataSource() {
      if (this.IsEditEnabled) return this.editingDataSource;
      else return this.dataSource;
    },

    /**
     * Computed property to get the child grid columns
     * @returns {Array} The child grid columns
     */
    getChildColumns() {
      return [
        {
          caption: "Bom Code",
          dataField: "BomCode",
          width: ColumnWidth.ProductCode.width,
          minWidth: ColumnWidth.ProductCode.minWidth,
          allowEditing: false,
        },
        {
          caption: "Description",
          dataField: "BomDescription1",
          minWidth: ColumnWidth.Description.minWidth,
          allowEditing: false,
        },
        {
          caption: "Batch Qty",
          dataField: "BatchSize",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: false,
        },
      ].concat(this.getWeekColumns(true));
    },

    /**
     * Computed property to get the visibility of the Copy Planning popup
     * @returns {boolean} The visibility of the Copy Planning popup
     */
    getCopyPlanningVisible() {
      return this.CopyProductPlanningVisible;
    },
  },
  methods: {
    /**
     * Function to navigate back to the MRP list page
     * @returns {void}
     */
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },

    /**
     * Function to handle the content ready event of the header form
     * @param {Object} e - The event object
     * @returns {void}
     */
    onHeaderFormContentReady(e) {
      // Get all elements with the class "gc-header-form".
      const headerForm = document.querySelectorAll(".gc-header-form");
      // Set the height of the header form.
      this.headerFormHeight = headerForm[0].clientHeight;

      // If the event exists and the mode is not "review", set the focus to the "DateIn" editor after a delay.
      if (e) {
        setTimeout(() => {
          var headerToolBarForm = e.component;
          if (headerToolBarForm && headerToolBarForm.getEditor("DateIn"))
            headerToolBarForm.getEditor("DateIn").instance().focus();
        }, 500);
      }
    },

    /**
     * Function to handle the content ready event of the header filter form
     * @returns {void}
     */
    onHeaderFilterFormContentReady() {},

    /**
     * Function to customize form items if needed
     * @param {Object} item - The form item to customize
     * @returns {Object} The customized form item
     */
    getCustomizeItem(item) {
      // Customize the item if needed
      return item;
    },

    /**
     * Function to handle the click event of the Review Plan button
     * Validates the header form and displays validation summary if invalid
     * @returns {Promise<void>}
     */
    async onReviewPlanClick() {
      await this.$store.dispatch("screenFactors/getFactors", [204]);
      let headerform = await validationEngine.validateGroup("gc-header-form");
      if (!headerform.isValid) {
        this.displayValidationSummary(headerform.brokenRules);
      } else {
        this.IsEditEnabled = false;
        this.editingDataSource.clear();
        this.dataSource.clear();
        this.ProductCodes = [];
        await this.$nextTick();
        try {
          this.showLoading(true);
          const response =
            await ProductionPlanningService.getProductionPlanningGrouped(
              this.getWeekRange(this.model.DateIn).startDate,
              this.getWeekRange(this.model.DateIn).endDate,
              this.buildFilterString(this.filterModel, this.model)
            );

          if (response && response.data && response.data.length > 0) {
            // Update the data source with the retrieved data
            response.data.forEach((item) => {
              item.Boms.forEach((bomItem) => {
                bomItem.ProductCode = item.ProductCode;
              });
              this.ProductCodes.push(item.ProductCode);
              this.editingDataSource.insert(item);
              if (item.TotalWeekQty > 0) this.dataSource.insert(item);
            });
          } else {
            this.dataSource = new ArrayStore({
              key: "VarietyCode",
              data: [],
            });
          }
        } catch (error) {
          this.showLoading(false);
          this.displayServerError(error);
        } finally {
          if (this.$refs["dx-data-grid-comp"]) {
            // Get the instance of the data grid component.
            var dataGrid = this.$refs["dx-data-grid-comp"].instance;
            this.$nextTick(() => {
              // Refresh the data grid to reflect the updated data source.
              dataGrid.refresh();
            });
          }

          this.IsPlanCreated = true;
          this.showLoading(false);
        }
      }
    },

    /**
     * Function to handle the toolbar preparing event of the data grid
     * @returns {void}
     */
    toolbarPreparing() {},

    /**
     * Function to convert various date inputs to a local Date object without time component
     * @param {string|Date|number} input - The input date in various formats
     * @returns {Date} The converted local Date object
     */
    toLocalDate(input) {
      if (!input && input !== 0) return new Date(NaN);

      if (input instanceof Date) {
        // Create a new Date with the same local Y/M/D (strip time)
        return new Date(input.getFullYear(), input.getMonth(), input.getDate());
      }

      if (typeof input === "string") {
        // Strictly support ISO-like "YYYY-MM-DD" first (common source of bugs)
        const m = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (m) {
          const year = Number(m[1]);
          const month = Number(m[2]) - 1; // zero-based
          const day = Number(m[3]);
          return new Date(year, month, day); // local date (no timezone shift)
        }

        // Try common separators (YYYY/MM/DD or YYYY.MM.DD or DD-MM-YYYY)
        // eslint-disable-next-line no-useless-escape
        const parts = input.split(/[-\/\.]/).map((p) => p.trim());
        if (parts.length >= 3) {
          // guess format: if first part length 4 => YYYY/MM/DD
          if (parts[0].length === 4) {
            return new Date(
              Number(parts[0]),
              Number(parts[1]) - 1,
              Number(parts[2])
            );
          }
          // fallback: attempt Date constructor (less reliable)
          const d = new Date(input);
          return new Date(d.getFullYear(), d.getMonth(), d.getDate());
        }

        // Last resort
        const d = new Date(input);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
      }

      // fallback for numbers etc.
      const d = new Date(input);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    },

    /**
     * Function to get the list of days based on the value of factor 204
     * @returns {Array} An array of day names based on the factor value
     */
    getDaysFromFactor204() {
      const factor = getFactorByCode(204);
      if (factor && factor.FactorInt != undefined) {
        this.factor204 = parseInt(factor.FactorInt);
      } else {
        this.factor204 = 0;
      }

      let days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

      if (this.factor204 == 1) {
        days.push("Saturday");
      } else if (this.factor204 == 2) {
        days.push("Saturday", "Sunday");
      }

      return days;
    },

    /**
     * Function to get all dates of the week (Monday to Sunday) for a given input date
     * @param {string} inputDate - The input date in YYYY-MM-DD format
     * @returns {Array} An array of objects containing day names and corresponding dates
     */
    getWeekDates(inputDate) {
      const date = this.toLocalDate(inputDate);
      if (isNaN(date)) return [];

      // day: 0 = Sun, 1 = Mon, ... 6 = Sat
      const dayIndex = date.getDay();

      // Calculate diff to Monday (if Sunday -> go back 6)
      const diffToMonday = dayIndex === 0 ? -6 : 1 - dayIndex;

      const monday = new Date(date);
      monday.setDate(date.getDate() + diffToMonday);

      const days = this.getDaysFromFactor204();

      const week = [];
      for (let i = 0; i < 7; i++) {
        const d = new Date(monday);
        d.setDate(monday.getDate() + i);
        // Format YYYY-MM-DD using local date parts
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        week.push({
          day: days[i],
          date: `${yyyy}-${mm}-${dd}`,
          index: i,
        });
      }

      return week;
    },

    /**
     * Function to get the start and end dates (Monday and Sunday) of the week for a given input date
     * @param {string} inputDate - The input date in YYYY-MM-DD format
     * @returns {Object} An object containing the startDate (Monday) and endDate (Sunday) in YYYY-MM-DD format
     */
    getWeekRange(inputDate) {
      const date = this.toLocalDate(inputDate);
      if (isNaN(date)) return { startDate: null, endDate: null };

      const day = date.getDay(); // 0 = Sun, 1 = Mon, ...

      const diffToMonday = day === 0 ? -6 : 1 - day;

      const monday = new Date(date);
      monday.setDate(date.getDate() + diffToMonday);

      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);

      const fmt = (d) =>
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(d.getDate()).padStart(2, "0")}`;

      return {
        startDate: fmt(monday),
        endDate: fmt(sunday),
      };
    },

    /**
     * Function to build the filter string for the API request
     * @param {Object} filterModel - The filter model containing filter criteria
     * @param {Object} dataModel - The data model containing additional criteria
     * @returns {string} The constructed filter string
     */
    buildFilterString(filterModel, dataModel) {
      const filters = [];

      // Handle filterModel (multi-value or single value)
      for (const [key, value] of Object.entries(filterModel)) {
        if (
          value == null ||
          value === "" ||
          (Array.isArray(value) && value.length === 0)
        ) {
          continue;
        }

        if (Array.isArray(value)) {
          // Multi-select → OR conditions inside parentheses
          const orConditions = value
            .map((v) => `${key} eq '${v}'`)
            .join(" or ");

          filters.push(`(${orConditions})`);
        } else {
          // Single value
          filters.push(`${key} eq '${value}'`);
        }
      }

      // Handle main model fields (still single select)
      const mainFields = ["BranchCode", "DivisionCode"];

      mainFields.forEach((field) => {
        const val = dataModel[field];
        if (val != null && val !== "") {
          filters.push(`${field} eq '${val}'`);
        }
      });

      // Return final filter string
      return filters.length ? filters.join(" and ") : null;
    },

    /**
     * Function to get the date header template for the data grid columns
     * @param {Object} data - The data object containing column information
     * @returns {Object} An object containing the caption and date for the header
     */
    getDateHeaderTemplate(data) {
      const dataField = data.column.dataField;

      // Extract the day from "TotalMonday" → "Monday"
      const dayName = dataField.replace("Total", "");

      const weekDates = this.getWeekDates(this.model.DateIn);

      const dayInfo = weekDates.find((day) => day.day === dayName);

      if (dayInfo) {
        return {
          caption: dayInfo.day,
          date: new Date(dayInfo.date + "T00:00:00").toShortDateString(),
        };
      }

      return {
        caption: data.column.caption,
        date: "",
      };
    },

    /**
     * Function to get the week columns for the data grid
     * @param {boolean} childLevel - Flag indicating if the columns are for child level
     * @returns {Array} An array of week column definitions
     */
    getWeekColumns(childLevel = false) {
      return [
        {
          caption: "Monday",
          dataField: childLevel ? "Monday" : "TotalMonday",
          headerCellTemplate: "dayHeaderCellTemplate",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: this.IsEditEnabled,
          cssClass: this.IsEditEnabled
            ? "edit-cell-numberbox-field gc-editable-cell-color"
            : undefined,
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
            onKeyDown: async (e, cellInfo) => {
              const dataGrid = this.getDataGridInstance();
              const { data, rowIndex } = cellInfo;
              if (backwardTabbing(e) && !childLevel) {
                if (rowIndex === 0) {
                  e.event.preventDefault();
                  this.focusOnHeaderFilterForm("Generate");
                  return;
                }

                this.focusOnBomListLastRecord(e, data);
              }

              if (backwardTabbing(e) && childLevel && rowIndex === 0) {
                const parentData = this.editingDataSource._array.find(
                  (parent) => parent.ProductCode === data.ProductCode
                );

                if (parentData) {
                  const parentRowIndex = dataGrid.getRowIndexByKey(
                    parentData.ID
                  );

                  const lastEditableDay = this.getLastEditableDay({
                    ...parentData,
                    ...this.getParentEditableDays(parentData),
                  });

                  if (parentRowIndex > -1) {
                    e.event.preventDefault();
                    // Move focus to parent row's last editable cell

                    if (parentRowIndex >= 0 && lastEditableDay) {
                      this.focusOnParentGridCell(
                        parentRowIndex,
                        "Total" + lastEditableDay
                      );
                    } else if (parentRowIndex === 0 && !lastEditableDay) {
                      this.focusOnHeaderFilterForm("Generate");
                    } else if (!lastEditableDay) {
                      this.focusOnBomListLastRecord(e, data);
                    }
                  }
                }
              }

              if (forwardTabbing(e) && !childLevel) {
                const nextEditableDay = this.getNextEditableDay(
                  {
                    ...data,
                    ...this.getParentEditableDays(data),
                  },
                  cellInfo.column.caption
                );

                if (nextEditableDay) {
                  e.event.preventDefault();
                  this.focusOnParentGridCell(
                    rowIndex,
                    "Total" + nextEditableDay
                  );
                } else {
                  this.focusOnBomListFirstRecord(e, data);
                }
              }
            },
          },
          setCellValue: this.getCommonSetCellValue("Monday", childLevel),
        },
        {
          caption: "Tuesday",
          dataField: childLevel ? "Tuesday" : "TotalTuesday",
          headerCellTemplate: "dayHeaderCellTemplate",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: this.IsEditEnabled,
          cssClass: this.IsEditEnabled
            ? "edit-cell-numberbox-field gc-editable-cell-color"
            : undefined,
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
            onKeyDown: async (e, cellInfo) => {
              this.forwordAndBackwordTabbkingOnMidDays(e, cellInfo, childLevel);
            },
          },
          setCellValue: this.getCommonSetCellValue("Tuesday", childLevel),
        },
        {
          caption: "Wednesday",
          dataField: childLevel ? "Wednesday" : "TotalWednesday",
          headerCellTemplate: "dayHeaderCellTemplate",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: this.IsEditEnabled,
          cssClass: this.IsEditEnabled
            ? "edit-cell-numberbox-field gc-editable-cell-color"
            : undefined,
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
            onKeyDown: async (e, cellInfo) => {
              this.forwordAndBackwordTabbkingOnMidDays(e, cellInfo, childLevel);
            },
          },
          setCellValue: this.getCommonSetCellValue("Wednesday", childLevel),
        },
        {
          caption: "Thursday",
          dataField: childLevel ? "Thursday" : "TotalThursday",
          headerCellTemplate: "dayHeaderCellTemplate",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: this.IsEditEnabled,
          cssClass: this.IsEditEnabled
            ? "edit-cell-numberbox-field gc-editable-cell-color"
            : undefined,
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
            onKeyDown: async (e, cellInfo) => {
              this.forwordAndBackwordTabbkingOnMidDays(e, cellInfo, childLevel);
            },
          },
          setCellValue: this.getCommonSetCellValue("Thursday", childLevel),
        },
        {
          caption: "Friday",
          dataField: childLevel ? "Friday" : "TotalFriday",
          headerCellTemplate: "dayHeaderCellTemplate",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: this.IsEditEnabled,
          cssClass: this.IsEditEnabled
            ? "edit-cell-numberbox-field gc-editable-cell-color"
            : undefined,
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
            onKeyDown: async (e, cellInfo) => {
              if (backwardTabbing(e) || this.factor204 != 0) {
                this.forwordAndBackwordTabbkingOnMidDays(
                  e,
                  cellInfo,
                  childLevel
                );
                return;
              }
              if (this.factor204 === 0) {
                this.tabOutFromLastDay(e, cellInfo, childLevel);
              }
            },
          },
          setCellValue: this.getCommonSetCellValue("Friday", childLevel),
        },
        {
          caption: "Saturday",
          dataField: childLevel ? "Saturday" : "TotalSaturday",
          headerCellTemplate: "dayHeaderCellTemplate",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: this.IsEditEnabled,
          cssClass: this.IsEditEnabled
            ? "edit-cell-numberbox-field gc-editable-cell-color"
            : undefined,
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
            onKeyDown: async (e, cellInfo) => {
              if (backwardTabbing(e) || this.factor204 != 1) {
                this.forwordAndBackwordTabbkingOnMidDays(
                  e,
                  cellInfo,
                  childLevel
                );
                return;
              }
              if (this.factor204 === 1) {
                this.tabOutFromLastDay(e, cellInfo, childLevel);
              }
            },
          },
          setCellValue: this.getCommonSetCellValue("Saturday", childLevel),
          visible: this.factor204 >= 1,
        },
        {
          caption: "Sunday",
          dataField: childLevel ? "Sunday" : "TotalSunday",
          headerCellTemplate: "dayHeaderCellTemplate",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: this.IsEditEnabled,
          cssClass: this.IsEditEnabled
            ? "edit-cell-numberbox-field gc-editable-cell-color"
            : undefined,
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
            onKeyDown: async (e, cellInfo) => {
              this.tabOutFromLastDay(e, cellInfo, childLevel);
            },
          },
          setCellValue: this.getCommonSetCellValue("Sunday", childLevel),
          visible: this.factor204 === 2,
        },
        {
          caption: "Total",
          dataField: "TotalWeekQty",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: false,
        },
      ];
    },

    /**
     * Function to handle forward and backward tabbing on mid-week days
     * @param {Object} e - The event object
     * @param {Object} cellInfo - The cell information
     * @param {boolean} childLevel - Flag indicating if the cell is at child level
     * @returns {void}
     */
    tabOutFromLastDay(e, cellInfo, childLevel) {
      const dataGrid = this.getDataGridInstance();
      const { data } = cellInfo;

      if (forwardTabbing(e) && !childLevel) {
        this.focusOnBomListFirstRecord(e, data);
      }

      if (forwardTabbing(e) && childLevel) {
        if (dataGrid) {
          const parentRowInfo = this.editingDataSource._array.find(
            (parent) => parent.ProductCode === data.ProductCode
          );

          if (parentRowInfo) {
            const boms = parentRowInfo.Boms;
            if (boms && boms.length > 0) {
              const currentBomIndex = boms.findIndex(
                (bom) => bom.BomCode === data.BomCode
              );

              if (currentBomIndex >= 0) {
                if (currentBomIndex === boms.length - 1) {
                  e.event.preventDefault();
                  // Last BOM, move to next parent row's Monday cell
                  var gridDS = dataGrid.getDataSource();
                  var loadOptions = gridDS.loadOptions();
                  gridDS
                    .store()
                    .load(loadOptions)
                    .done(async (loadedItems) => {
                      let index = loadedItems.findIndex(
                        (x) => x.ID == parentRowInfo.ID
                      );

                      if (index != -1 && index < loadedItems.length - 1) {
                        const getNextParentRow = loadedItems[index + 1];
                        if (getNextParentRow) {
                          const nextEditableDay = this.getNextEditableDay(
                            {
                              ...getNextParentRow,
                              ...this.getParentEditableDays(getNextParentRow),
                            },
                            cellInfo.column.caption
                          );

                          if (nextEditableDay) {
                            const getNextParentRowIndex =
                              dataGrid.getRowIndexByKey(getNextParentRow.ID);

                            if (getNextParentRowIndex != -1) {
                              setTimeout(() => {
                                this.focusOnParentGridCell(
                                  getNextParentRowIndex,
                                  "Total" + nextEditableDay
                                );
                              }, 10);
                            }
                          } else {
                            this.focusOnBomListFirstRecord(e, getNextParentRow);
                          }
                        }
                      }
                    });
                }
              }
            }
          }
        }
      }
    },

    /**
     * Function to handle the cell prepared event of the data grid
     * @param {Object} e - The event object
     * @returns {void}
     */
    onCellPrepared(e) {
      if (e.rowType === "data" && e.column.command === "expand") {
        if (
          e.data.Boms &&
          (e.data.Boms.length === 0 || e.data.Boms.length === 1)
        ) {
          e.cellElement.classList.remove("dx-datagrid-expand");
          e.cellElement.childNodes[0].classList.remove(
            "dx-datagrid-group-closed"
          );
        }
      }

      if (e.rowType == "data" && this.IsEditEnabled) {
        const data = e.data;
        const caption = e.column.caption;
        if (data && e.column.allowEditing) {
          if (data.TotalWeekQty > 0) {
            const bomValue = data.Boms.find(
              (bom) => bom.BomCode !== data.PrimaryBomCode && bom[caption] > 0
            );

            if (bomValue) {
              e.cellElement.classList.remove("gc-editable-cell-color");
            }
          }
        }
      }
    },

    /**
     * Function to handle the editor preparing event of the data grid
     * Disables editing for certain cells based on BOM conditions
     * @param {Object} e - The event object
     * @returns {void}
     */
    onEditorPreparing(e) {
      const data = e.row.data;
      if (
        e.parentType == "dataRow" &&
        this.IsEditEnabled &&
        data &&
        data.Boms &&
        data.PrimaryBomCode &&
        data.Boms.length > 1
      ) {
        // Check if any non-primary BOM has a value for the current day
        const dayField = e.dataField;
        if (
          [
            "TotalMonday",
            "TotalTuesday",
            "TotalWednesday",
            "TotalThursday",
            "TotalFriday",
            "TotalSaturday",
            "TotalSunday",
          ].includes(dayField)
        ) {
          const dayName = dayField.replace("Total", "");
          const nonPrimaryHasValue = data.Boms.some(
            (bom) =>
              bom.BomCode !== data.PrimaryBomCode &&
              bom[dayName] &&
              bom[dayName] > 0
          );
          if (nonPrimaryHasValue) {
            e.editorOptions.disabled = true;
          }
        }
      }

      if (e.parentType != "searchPanel") {
        let func = e.editorOptions.onKeyDown;
        e.editorOptions.onKeyDown = (event) => {
          func(event, {
            column: {
              dataField: e.dataField,
              caption: e.caption,
            },
            data: e.row.data,
            rowIndex: e.row.rowIndex,
          });
        };
      }
    },

    /**
     * Function to handle the child editor preparing event of the data grid
     * @param {Object} e - The event object
     * @returns {void}
     */
    onChildEditorPreparing(e) {
      if (e.parentType != "searchPanel") {
        let func = e.editorOptions.onKeyDown;
        e.editorOptions.onKeyDown = (event) => {
          func(event, {
            column: {
              dataField: e.dataField,
            },
            data: e.row.data,
            rowIndex: e.row.rowIndex,
          });
        };
      }
    },

    /**
     * Function to handle the content ready event of the data grid
     * @param {Object} e - The event object
     * @returns {void}
     */
    onContentReady(e) {
      if (e) {
        this.$nextTick(() => {
          if (
            this.editingDataSource &&
            this.editingDataSource._array &&
            this.editingDataSource._array.length > this.dataSource._array.length
          ) {
            this.addGridNoResults(e, {
              addNew: {
                class: "no-data",
                title: "Edit Mode: Hidden Rows Available",
                message:
                  "You are now able to edit rows with zero quantity. Add quantities as needed.",
              },
            });
          } else {
            this.addGridNoResults(e, {
              addNew: {
                class: "no-data",
                title: "No production planning data found.",
                message: "Please adjust your filters and try again.",
              },
            });
          }
        });
      }
    },

    /**
     * Function to handle the click event of the Edit Plan button
     * Enables edit mode for the production plan
     * @returns {void}
     */
    async onEditPlanClick() {
      this.IsEditEnabled = true;

      this.showLoading(true);
      try {
        const response = await ProductionPlanningService.getBomProducts(
          this.buildFilterString(this.filterModel, this.model)
        );

        if (IsResponseDataValid(response)) {
          response.data.value.forEach((item) => {
            const findItem = this.editingDataSource._array.find(
              (prod) => prod.ProductCode === item.ProductCode
            );
            if (findItem) {
              if (!findItem.Boms) {
                item.BomList.map((bom) => {
                  return {
                    BomCode: bom.Code,
                    BomDescription1: bom.Description1,
                    BatchSize: bom.BatchSize,
                    Monday: 0,
                    Tuesday: 0,
                    Wednesday: 0,
                    Thursday: 0,
                    Friday: 0,
                    Saturday: 0,
                    Sunday: 0,
                    TotalWeekQty: 0,
                    ProductCode: findItem.ProductCode,
                  };
                });
                findItem.Boms = item.BomList;
              } else {
                item.BomList.forEach((bom) => {
                  const exists = findItem.Boms.find(
                    (b) => b.BomCode === bom.Code
                  );
                  if (!exists) {
                    const getBom = {
                      BomCode: bom.Code,
                      BomDescription1: bom.Description1,
                      BatchSize: bom.BatchSize,
                      Monday: 0,
                      Tuesday: 0,
                      Wednesday: 0,
                      Thursday: 0,
                      Friday: 0,
                      Saturday: 0,
                      Sunday: 0,
                      TotalWeekQty: 0,
                      ProductCode: findItem.ProductCode,
                    };
                    findItem.Boms.push(getBom);
                  }
                });
              }
            } else {
              const parent = {
                BranchCode: item.BranchCode,
                DivisionCode: item.DivisionCode,
                ProductCode: item.ProductCode,
                ProductDescription1: item.ProductDescription1,
                BatchSize: item.BatchSize,
                PrimaryBomCode: item.PrimaryBomCode,
                TotalMonday: 0,
                TotalTuesday: 0,
                TotalWednesday: 0,
                TotalThursday: 0,
                TotalFriday: 0,
                TotalSaturday: 0,
                TotalSunday: 0,
                TotalWeekQty: 0,
                Boms: item.BomList.map((bom) => {
                  return {
                    BomCode: bom.Code,
                    BomDescription1: bom.Description1,
                    BatchSize: bom.BatchSize,
                    Monday: 0,
                    Tuesday: 0,
                    Wednesday: 0,
                    Thursday: 0,
                    Friday: 0,
                    Saturday: 0,
                    Sunday: 0,
                    TotalWeekQty: 0,
                    ProductCode: item.ProductCode,
                  };
                }),
              };

              this.editingDataSource.insert(parent);
            }
          });
        }
      } catch (error) {
        this.showLoading(false);
        this.displayServerError(error);
      } finally {
        this.showLoading(false);
        this.$nextTick(() => {
          if (!this.$refs["dx-data-grid-comp"]) return;
          // Get the instance of the data grid component.
          var dataGrid = this.$refs["dx-data-grid-comp"].instance;
          // Refresh the data grid to reflect the updated data source.
          dataGrid.refresh();
        });
      }
    },

    /**
     * Function to handle the value changed event of the DateIn field
     * Prompts confirmation if changing the date will clear the current plan
     * @param {Object} e - The event object
     * @returns {Promise<void>}
     */
    async onDateInValueChanged(e) {
      if (!e.event) return;
      // const newDate = e.value;
      // const oldDate = e.previousValue;

      // if (!newDate || !oldDate) {
      //   // First time selection → no comparison
      //   this.IsPlanCreated = false;
      //   return;
      // }

      // const newWeek = this.getWeekRange(newDate);
      // const oldWeek = this.getWeekRange(oldDate);

      // const isNewWeek =
      //   newWeek.startDate !== oldWeek.startDate ||
      //   newWeek.endDate !== oldWeek.endDate;

      // if (isNewWeek && this.IsPlanCreated && this.IsEditEnabled) {
      //   const confirm = await this.$confirm(
      //     "Changing the date will clear the current plan. Do you want to continue?",
      //     "Confirm Date Change"
      //   );

      //   if (!confirm) {
      //     // Revert to old date
      //     e.component.option("value", oldDate);
      //     return;
      //   } else {
      //     this.IsPlanCreated = false;
      //   }
      // }
    },

    /**
     * Function to refresh the data source of the data grid
     * @returns {void}
     */
    refreshDataSource(productCode) {
      if (this.$refs["dx-data-grid-comp"]) {
        // Get the instance of the data grid component.
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        this.$nextTick(() => {
          // Refresh the data grid to reflect the updated data source.
          dataGrid.refresh(true);

          if (productCode) {
            const childGrid = this.getChildGridInstance(productCode);
            if (childGrid) {
              childGrid.refresh(true);
            }
          }
        });
      }
    },

    /**
     * Function to get the instance of the main data grid
     * @returns {Object|null} The data grid instance or null if not found
     */
    getDataGridInstance() {
      if (this.$refs["dx-data-grid-comp"]) {
        return this.$refs["dx-data-grid-comp"].instance;
      }
      return null;
    },

    /**
     * Function to get the instance of a child data grid by key
     * @param {string} key - The key of the child grid
     * @returns {Object|null} The child grid instance or null if not found
     */
    getChildGridInstance(key) {
      const gridKey = "master-grid-" + key;
      if (this.$refs[gridKey]) {
        return this.$refs[gridKey].instance;
      }
      return null;
    },

    /**
     * Function to refocus on a cell with negative quantity after validation
     * @param {Object} currentRowData - The current row data
     * @param {boolean} isChildLevel - Flag indicating if the row is at child level
     * @param {string} column - The data field of the column to focus on
     * @returns {void}
     */
    refocusOnNegativeQuantityCell(currentRowData, isChildLevel, column) {
      this.$nextTick(() => {
        if (isChildLevel) {
          const childGrid = this.getChildGridInstance(
            currentRowData.ProductCode
          );
          if (childGrid) {
            const rowIndex = childGrid.getRowIndexByKey(currentRowData);
            if (rowIndex !== -1) {
              this.focusOnChildGridCell(
                currentRowData.ProductCode,
                rowIndex,
                column
              );
            }
          }
        } else {
          const dataGrid = this.getDataGridInstance();
          const rowIndex = dataGrid.getRowIndexByKey(currentRowData.ID);
          if (rowIndex !== -1) {
            this.focusOnParentGridCell(rowIndex, column);
          }
        }
      });
    },

    /**
     * Function to focus and edit a specific cell in the parent data grid
     * @param {number} rowIndex - The index of the row
     * @param {string} column - The data field of the column
     * @returns {void}
     */
    focusOnParentGridCell(rowIndex, column) {
      const dataGrid = this.getDataGridInstance();
      const cellElement = dataGrid.getCellElement(rowIndex, column);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, column);
      }, 10);
    },

    /**
     * Function to focus and edit a specific cell in a child data grid
     * @param {string} productCode - The product code identifying the child grid
     * @param {number} rowIndex - The index of the row
     * @param {string} column - The data field of the column
     * @returns {void}
     */
    focusOnChildGridCell(productCode, rowIndex, column) {
      const childGrid = this.getChildGridInstance(productCode);
      if (childGrid) {
        const cellElement = childGrid.getCellElement(rowIndex, column);
        childGrid.focus(cellElement);
        setTimeout(() => {
          childGrid.editCell(rowIndex, column);
        }, 10);
      }
    },

    /**
     * Function to determine which days are editable for a parent row
     * based on the values of its non-primary BOMs
     * @param {Object} row - The parent row data
     * @returns {Object} An object with boolean flags for each day's editability
     */
    getParentEditableDays(row) {
      const days = this.getDaysFromFactor204();

      const primary = row.PrimaryBomCode;

      // Filter out non-primary Boms
      const nonPrimaryBoms = row.Boms.filter((b) => b.BomCode !== primary);

      const editable = {};

      for (const day of days) {
        // Check if any non-primary BOM has a value > 0 for this day
        const hasValue = nonPrimaryBoms.some((b) => (b[day] || 0) > 0);

        // If ANY non-primary BOM has value, parent day is NOT editable
        editable[`${day}Editable`] = !hasValue;
      }

      return editable;
    },

    /**
     * Function to get the next editable day for a given row and current day
     * @param {Object} row - The row data
     * @param {string} currentDay - The current day (e.g., "Monday")
     * @returns {string|null} The next editable day or null if none found
     */
    getNextEditableDay(row, currentDay = null) {
      const days = this.getDaysFromFactor204();

      let startIndex = 0;

      // If a currentDay is provided, start after that day
      if (currentDay && days.includes(currentDay)) {
        startIndex = days.indexOf(currentDay) + 1;
      }

      // Search forward for the first editable day
      for (let i = startIndex; i < days.length; i++) {
        const key = `${days[i]}Editable`;
        if (row[key] === true) {
          return days[i];
        }
      }

      return null; // no editable day found
    },

    /**
     * Function to get the last editable day for a given row
     * @param {Object} row - The row data
     * @returns {string|null} The last editable day or null if none found
     */
    getLastEditableDay(row) {
      const days = this.getDaysFromFactor204().reverse();

      for (const day of days) {
        const key = `${day}Editable`;
        if (row[key] === true) {
          return day; // or return the key
        }
      }

      return null; // none editable
    },

    /**
     * Function to get the previous editable day for a given row and current day
     * @param {Object} row - The row data
     * @param {string} currentDay - The current day (e.g., "Monday")
     * @returns {string|null} The previous editable day or null if none found
     */
    getPreviousEditableDay(row, currentDay) {
      const days = this.getDaysFromFactor204();

      const currentIndex = days.indexOf(currentDay);

      // Start from the day BEFORE the current day
      for (let i = currentIndex - 1; i >= 0; i--) {
        const key = `${days[i]}Editable`;
        if (row[key] === true) {
          return days[i];
        }
      }

      return null; // no editable day before current
    },

    /**
     * Function to focus on the last record of the BOM list in the previous parent row
     * @param {Object} e - The event object
     * @param {Object} data - The current row data
     * @returns {void}
     */
    focusOnBomListLastRecord(e, data) {
      if (data.ID === undefined && data.Boms === undefined) {
        const findItemline = this.editingDataSource._array.find(
          (prod) => prod.ProductCode === data.ProductCode
        );

        if (findItemline) {
          data = findItemline;
        }
      }

      const dataGrid = this.getDataGridInstance();
      var gridDS = dataGrid.getDataSource();
      var loadOptions = gridDS.loadOptions();

      gridDS
        .store()
        .load(loadOptions)
        .done(async (loadedItems) => {
          let index = loadedItems.findIndex((x) => x.ID == data.ID);

          if (index != -1 && index > 0) {
            if (loadedItems[index - 1].Boms.length > 1) {
              e.event.preventDefault();
              // Move to last editable cell of previous row's child grid
              dataGrid.expandRow(loadedItems[index - 1].ID);
              await this.$nextTick();
              setTimeout(() => {
                const prevRowMasterGridRef = this.getChildGridInstance(
                  loadedItems[index - 1].ProductCode
                );

                const getRowIndex = prevRowMasterGridRef.getRowIndexByKey(
                  loadedItems[index - 1].Boms[
                    loadedItems[index - 1].Boms.length - 1
                  ]
                );

                if (!getRowIndex || getRowIndex < 0) return;
                if (prevRowMasterGridRef) {
                  const days = this.getDaysFromFactor204();
                  this.focusOnChildGridCell(
                    loadedItems[index - 1].ProductCode,
                    getRowIndex,
                    days[days.length - 1]
                  );
                }
              }, 100);
            } else {
              // If previous row has no BOMs or only one, continue to move up
              const lastEditableDay = this.getLastEditableDay({
                ...loadedItems[index - 1],
                ...this.getParentEditableDays(loadedItems[index - 1]),
              });

              if (lastEditableDay) {
                this.focusOnParentGridCell(
                  dataGrid.getRowIndexByKey(loadedItems[index - 1].ID),
                  "Total" + lastEditableDay
                );
              }
            }
          }
        });
    },

    /**
     * Function to focus on the first record of the BOM list in the current parent row
     * @param {Object} e - The event object
     * @param {Object} data - The current row data
     * @returns {void}
     */
    focusOnBomListFirstRecord(e, data) {
      const dataGrid = this.getDataGridInstance();
      if (data && data.Boms && data.PrimaryBomCode && data.Boms.length > 1) {
        if (e.event) e.event.preventDefault();
        if (e.component) e.component.blur();

        if (dataGrid) {
          if (dataGrid.isRowExpanded(data.ID)) {
            const childGrid = this.getChildGridInstance(data.ProductCode);
            if (childGrid) {
              this.focusOnChildGridCell(data.ProductCode, 0, "Monday");
            }
          } else {
            dataGrid.expandRow(data.ID).then(() => {
              setTimeout(() => {
                this.$nextTick(() => {
                  const childGrid = this.getChildGridInstance(data.ProductCode);
                  if (childGrid) {
                    this.focusOnChildGridCell(data.ProductCode, 0, "Monday");
                  }
                });
              }, 100);
            });
          }
        }
      } else {
        var gridDS = dataGrid.getDataSource();
        var loadOptions = gridDS.loadOptions();
        gridDS
          .store()
          .load(loadOptions)
          .done(async (loadedItems) => {
            let index = loadedItems.findIndex((x) => x.ID == data.ID);

            if (index != -1 && index < loadedItems.length - 1) {
              const getNextParentRow = loadedItems[index + 1];
              if (getNextParentRow) {
                const nextEditableDay = this.getNextEditableDay({
                  ...getNextParentRow,
                  ...this.getParentEditableDays(getNextParentRow),
                });

                if (nextEditableDay) {
                  const getNextParentRowIndex = dataGrid.getRowIndexByKey(
                    getNextParentRow.ID
                  );

                  if (getNextParentRowIndex != -1) {
                    setTimeout(() => {
                      this.focusOnParentGridCell(
                        getNextParentRowIndex,
                        "Total" + nextEditableDay
                      );
                    }, 10);
                  }
                } else {
                  this.focusOnBomListFirstRecord(e, getNextParentRow);
                }
              }
            }
          });
      }
    },

    /**
     * Function to handle forward and backward tabbing on mid-week days
     * @param {Object} e - The event object
     * @param {Object} cellInfo - Information about the cell
     * @param {boolean} childLevel - Indicates if the cell is in a child grid
     * @returns {void}
     */
    forwordAndBackwordTabbkingOnMidDays(e, cellInfo, childLevel) {
      const { data, rowIndex } = cellInfo;
      if (forwardTabbing(e) && !childLevel) {
        const nextEditableDay = this.getNextEditableDay(
          {
            ...data,
            ...this.getParentEditableDays(data),
          },
          cellInfo.column.caption
        );

        if (nextEditableDay) {
          e.event.preventDefault();
          this.focusOnParentGridCell(rowIndex, "Total" + nextEditableDay);
        } else {
          this.focusOnBomListFirstRecord(e, data);
        }
      }

      if (backwardTabbing(e) && !childLevel) {
        e.event.preventDefault();

        const lastEditableDay = this.getPreviousEditableDay(
          {
            ...data,
            ...this.getParentEditableDays(data),
          },
          cellInfo.column.caption
        );

        if (lastEditableDay) {
          this.focusOnParentGridCell(rowIndex, "Total" + lastEditableDay);
        } else {
          if (rowIndex === 0) {
            e.event.preventDefault();
            this.focusOnHeaderFilterForm("Generate");
            return;
          }
          this.focusOnBomListLastRecord(e, data);
        }
      }
    },

    /**
     * Function to save the production plan for a specific cell and day
     * @param {Object} cell - The cell data
     * @param {string} dayField - The day field (e.g., "Monday")
     * @returns {void}
     */
    async onSaveProductionPlan(cell, dayField, currentRowData) {
      const dateHeader = this.getDateHeaderTemplate({
        column: { dataField: dayField },
      });
      const productionDate = new Date(dateHeader.date).toYMD();

      let payload = {
        ProductCode: cell.ProductCode,
        ProductionDate: productionDate,
        BranchCode: this.model.BranchCode,
        DivisionCode: this.model.DivisionCode,
      };

      if (cell.Boms) {
        const primaryBom = cell.Boms.find(
          (bom) => bom.BomCode === cell.PrimaryBomCode
        );
        if (primaryBom) {
          payload.BomCode = primaryBom.BomCode;
          payload.PlannedQty = primaryBom[dayField];
        }
      } else {
        payload.BomCode = cell.BomCode;
        payload.PlannedQty = cell[dayField];
      }

      try {
        // eslint-disable-next-line no-unused-vars
        const response = await ProductionPlanningService.saveProductionPlanning(
          payload
        );

        // Assuming response contains updated data for all related rows
        if (response && response.data && response.data.length > 0) {
          const data = response.data;

          // Update the data source with the new planned quantities
          data.forEach((element) => {
            // Find the corresponding item in the data source
            const findItem = this.editingDataSource._array.find(
              (prod) =>
                prod.ProductCode === element.ProductCode &&
                element.ProductCode !== cell.ProductCode
            );

            if (findItem) {
              // Update the specific day's quantity
              const prevTotalQtyByDay = findItem["Total" + dayField] || 0;
              if (findItem.Boms) {
                const findBom = findItem.Boms.find(
                  (bom) => bom.BomCode === element.BomCode
                );
                if (findBom) {
                  // Update the specific day's quantity
                  const previousQty = findBom[dayField] || 0;
                  findBom.TotalWeekQty =
                    findBom.TotalWeekQty - previousQty + element.NewPlannedQty;
                  findBom[dayField] = element.NewPlannedQty;
                }

                const DayTotal = findItem.Boms.reduce(function (prev, cur) {
                  return prev + cur[dayField];
                }, 0).roundNumber(2);

                findItem["Total" + dayField] = DayTotal;
              } else {
                // Update the parent row's specific day's quantity
                findItem["Total" + dayField] = element.NewPlannedQty;
              }

              findItem.TotalWeekQty =
                findItem.TotalWeekQty -
                prevTotalQtyByDay +
                findItem["Total" + dayField];

              // update week total
              this.editingDataSource.update(findItem.ID, findItem).then(() => {
                const getRowIndex = this.getDataGridInstance().getRowIndexByKey(
                  findItem.ID
                );
                // Refresh only the updated row
                if (getRowIndex !== -1) {
                  this.getDataGridInstance().repaintRows([getRowIndex]);
                }

                // Refresh the main grid
                this.$nextTick(() => {
                  this.getDataGridInstance().refresh(true);
                });
              });
            }
          });
        }
      } catch (error) {
        if (
          error &&
          error.data &&
          error.data.value &&
          typeof error.data.value === "string"
        ) {
          await this.$alert(error.data.value, "Error Saving Production Plan");

          if (cell.ID) {
            const dataGrid = this.getDataGridInstance();
            const rowIndex = dataGrid.getRowIndexByKey(cell.ID);
            if (rowIndex !== -1) {
              this.focusOnParentGridCell(rowIndex, "Total" + dayField);
              this.$nextTick(() => {
                dataGrid.cellValue(
                  rowIndex,
                  "Total" + dayField,
                  currentRowData["Total" + dayField]
                );
              });
            }
          } else {
            const childGrid = this.getChildGridInstance(cell.ProductCode);
            if (childGrid) {
              const rowIndex = childGrid.getRowIndexByKey(cell);
              if (rowIndex !== -1) {
                this.focusOnChildGridCell(cell.ProductCode, rowIndex, dayField);
                this.$nextTick(() => {
                  childGrid.cellValue(
                    rowIndex,
                    dayField,
                    currentRowData[dayField]
                  );
                });
              }
            }
          }
        } else {
          this.displayServerError(error);
        }
      }
    },

    /**
     * Function to focus on a specific header filter form field
     * @param {string} dataField - The data field to focus on
     * @returns {void}
     */
    focusOnHeaderFilterForm(dataField) {
      const formInstance =
        this.$refs["gc-header-form-filter"].$refs["gc-form-comp"].instance;

      if (formInstance && formInstance.getEditor(dataField))
        formInstance.getEditor(dataField).instance().focus();
    },

    /**
     * Function to handle field data changes in the header filter form
     * @param {Object} e - The event object containing dataField information
     * @returns {void}
     */
    onFieldDataChanged(e) {
      if (e && this.IsPlanCreated) {
        this.onHeaderFormContentReady(false);
        const dataGrid = this.getDataGridInstance();
        if (!dataGrid) return;
        this.$nextTick(() => {
          dataGrid.beginUpdate();
          dataGrid.option("height", this.getGridHeight);
          // dataGrid.updateDimensions();
          dataGrid.endUpdate();

          setTimeout(() => {
            this.focusOnHeaderFilterForm(e.dataField);
          }, 100);
        });
      }
    },

    // Copy Production Plan Functionality

    /**
     * Function to set the visibility of the Copy Production Planning popup
     * and configure its parameters based on the current model
     * @param {boolean} value - The visibility state of the popup
     * @returns {void}
     */
    setCopyPlanningVisible(value) {
      this.popUpConfig = {
        DateIn: new Date(this.model.DateIn).toFilterDateStartTime(),
        BranchCode: this.model.BranchCode,
        DivisionCode: this.model.DivisionCode,
      };
      this.CopyProductPlanningVisible = value;
    },

    /**
     * Function to get a common setCellValue handler for day columns
     * Handles validation and updates for both parent and child rows
     * @param {string} dayName - The name of the day (e.g., "Monday")
     * @param {boolean} childLevel - Indicates if the row is at child level
     * @returns {Function} The setCellValue handler function
     */
    getCommonSetCellValue(dayName, childLevel) {
      const childField = dayName;
      const parentField = "Total" + dayName;

      return (newData, value, currentRowData) => {
        // Negative value
        if (value < 0) {
          // Show alert asynchronously
          this.$alert("Quantity cannot be negative.", "Invalid Input").then(
            () => {
              this.refocusOnNegativeQuantityCell(
                currentRowData,
                childLevel,
                childLevel ? childField : parentField
              );
            }
          );

          // Revert value synchronously
          return currentRowData[childLevel ? childField : parentField];
        }

        // Child row
        if (childLevel) {
          newData[childField] = value;

          const parent = this.editingDataSource._array.find(
            (x) => x.ProductCode === currentRowData.ProductCode
          );

          if (parent) {
            parent[parentField] =
              parent[parentField] - currentRowData[childField] + value;
            parent.TotalWeekQty =
              parent.TotalWeekQty - currentRowData[childField] + value;

            this.editingDataSource.update(parent.ID, parent);
            this.refreshDataSource();
          }
        }
        // Parent row
        else {
          newData[parentField] = value;

          const primaryBom = currentRowData.Boms.find(
            (bom) => bom.BomCode === currentRowData.PrimaryBomCode
          );

          if (primaryBom) {
            primaryBom.TotalWeekQty =
              primaryBom.TotalWeekQty - primaryBom[dayName] + value;
            primaryBom[dayName] = value;
            newData.Boms = currentRowData.Boms;
          }
        }

        // Update total week qty
        newData.TotalWeekQty =
          currentRowData.TotalWeekQty -
          currentRowData[childLevel ? childField : parentField] +
          value;

        this.onSaveProductionPlan(
          {
            ...currentRowData,
            ...newData,
          },
          dayName,
          currentRowData
        );

        return newData;
      };
    },

    /**
     * Function to refresh the production planning data for a new date
     * @param {Date} dateIn - The new date for production planning
     * @returns {void}
     */
    onRefreshPlanning(dateIn) {
      this.model.DateIn = new Date(dateIn);
      this.IsPlanCreated = false;
      this.IsEditEnabled = false;
      this.onReviewPlanClick();
    },
  },
  watch: {
    /**
     * Watcher for the getHotKeySave computed property
     * Triggers the onGenerateClick method when getHotKeySave is true
     * @param {boolean} value - The new value of getHotKeySave
     * @returns {void}
     */
    getHotKeySave(value) {
      if (value && !this.getHotKeyPopupMode) {
        this.$store.dispatch("hotKey/setHotKeySave", false);
      }
    },

    /**
     * Watcher for the getHotKeyEdit computed property
     * Triggers the onEditPlanClick method when getHotKeyEdit is true
     * @param {boolean} value - The new value of getHotKeyEdit
     * @returns {void}
     */
    getHotKeyEdit(value) {
      if (value) {
        this.$store.dispatch("hotKey/setHotKeyEdit", false);
        if (!this.IsEditEnabled) {
          this.onEditPlanClick();
        }
      }
    },
  },
};
</script>

<style lang="scss">
.production-planning-layout {
  .filter-section {
    margin-top: 12px !important;

    .dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(
        .dx-editor-outlined
      ).dx-state-hover::after,
    .dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(
        .dx-editor-outlined
      )::after {
      border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
    }

    .dx-tagbox:not(.dx-texteditor-empty)
      .dx-texteditor-input-container.dx-tag-container {
      padding: unset !important;
    }
  }
  .generate-button-group {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .dx-widget.dx-collection {
      > .dx-box {
        flex-direction: row !important;
        gap: 20px;
      }
    }

    .btn-clear {
      padding-top: 5px !important;
      gap: 20px;
    }
  }

  .dx-master-detail-row {
    .dx-datagrid.dx-gridbase-container .dx-datagrid-header-panel {
      display: none !important;
    }

    > .dx-master-detail-cell {
      padding-left: 10px !important;
      padding-right: 0px !important;

      > .dx-widget.dx-card {
        max-width: unset !important;
      }
    }
  }

  .gc-editable-cell-color[role="gridcell"]:not(.cell-disabled) {
    background-color: #f8fdfe !important;
  }

  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row .dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .edit-cell-numberbox-field {
    .dx-numberbox.dx-texteditor:not(.dx-state-readonly)::after {
      content: "";
      border-bottom: unset !important;
      background-color: unset !important;
    }
    .dx-numberbox.dx-texteditor.dx-state-readonly {
      border-bottom-style: unset !important;
      border-bottom-width: unset !important;
    }
  }
}
</style>
